export default __webpack_public_path__ + "static/media/meta.02cc7705.svg";